import React, { useEffect, useRef, useState } from 'react';
import { Modal, Spin } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  PageContent,
  PageContentHeader,
  SubTitle,
  ContentWrapper,
  SectionContainer,
  StyledAlert,
  GlobalPopupButtonStyles
} from './styled';
import CategorySelection from './CategorySelection';
import {
  getCategories,
  getLiveSets,
  postSegmentSets
} from '../../../redux/actions/settings';
import CombinationSelection from './CombinationSelection';
import CombinationDetails from './CombinationDetails';

const { success } = Modal;

const CreateSegementSets = ({
  dispatch,
  segmentCategories,
  segmentLiveSets,
  isLoading,
  errorMsg,
  showSuccessMsg
}) => {
  const [selectedCategories, setSelectedCategories] = useState({});
  const categoriesList = segmentCategories?.data?.categories || [];
  const detailsRef = useRef(null);

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getLiveSets());
  }, []);

  useEffect(() => {
    if (showSuccessMsg) {
      success({
        title: 'Success',
        className: 'segment-button-color',
        content:
          'Segment configuration is successfully saved and can be used for configuring the run instance',
        onOk: () => {
          setSelectedCategories({});
          dispatch(getLiveSets());
          detailsRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
          });
        }
      });
    }
  }, [showSuccessMsg]);

  useEffect(() => {
    if (errorMsg) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [errorMsg]);

  const onProceedClick = (categories) => {
    setSelectedCategories(categories);
  };

  const onSave = (selectedCombinations) => {
    dispatch(
      postSegmentSets({
        combinations: selectedCombinations
      })
    );
  };

  return (
    <PageContent>
      <Spin
        spinning={
          segmentCategories?.isLoading ||
          segmentLiveSets?.isLoading ||
          isLoading
        }>
        {errorMsg && <StyledAlert type="error" message={errorMsg} />}
        <PageContentHeader>
          Create New Segmentation Configuration
          <SubTitle>Segment configuration screen for FRAML Detection</SubTitle>
        </PageContentHeader>
        <ContentWrapper>
          <SectionContainer>
            <CategorySelection
              selectedValues={selectedCategories}
              categoriesList={categoriesList}
              onProceedClick={onProceedClick}
            />
            <CombinationSelection
              categoriesList={categoriesList}
              selectedCategories={selectedCategories}
              onSave={onSave}
            />
          </SectionContainer>
        </ContentWrapper>
        <br />
        <br />
        <ContentWrapper>
          <PageContentHeader>
            Current Live Set Being Used
            <SubTitle>Update the above to reset the live sets</SubTitle>
          </PageContentHeader>
          <SectionContainer ref={detailsRef}>
            <CombinationDetails segmentLiveSets={segmentLiveSets?.data || {}} />
          </SectionContainer>
        </ContentWrapper>
        <br />
      </Spin>
      <GlobalPopupButtonStyles />
    </PageContent>
  );
};

CreateSegementSets.propTypes = {
  dispatch: PropTypes.func.isRequired,
  segmentCategories: PropTypes.object,
  segmentLiveSets: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  errorMsg: PropTypes.string,
  showSuccessMsg: PropTypes.bool.isRequired
};

const mapStateToProps = ({
  settings: {
    createRunInstanceCategories,
    createRunInstanceLiveSets,
    postSegmentSets: { isLoading, errorMsg, showSuccessMsg }
  }
}) => ({
  segmentCategories: createRunInstanceCategories,
  segmentLiveSets: createRunInstanceLiveSets,
  isLoading,
  errorMsg,
  showSuccessMsg
});

export default connect(mapStateToProps)(CreateSegementSets);
